import { Trans } from "@lingui/macro";
import { IApiSmpGptAgent } from "@smp/api";
import { UiButton, UiTypography } from "@smp/ui";
import { IconPlus, IconWand } from "@tabler/icons-react";
import { FC } from "react";

import { dialogAdvisorConfig } from "@/screens/app/components/dialogs/dialog_advisor";

import classes from "./agent_list.module.css";
import placeholderIcn from "./assets/robo@2x.png";
import { AgentCard, IAgentCardProps } from "./components/agent_card";

export interface IAgentListProps {
  value: IApiSmpGptAgent[];
  updatedAgentId: IApiSmpGptAgent["id"] | undefined;
  onCreate: () => void;
  onEdit: IAgentCardProps["onEdit"];
  onGenerate: IAgentCardProps["onGenerate"];
}

export const AgentList: FC<IAgentListProps> = ({
  value,
  updatedAgentId,
  onCreate,
  onEdit,
  onGenerate,
}) => {
  if (!value.length) {
    return (
      <>
        <div className={classes.placeholder}>
          <img
            src={placeholderIcn}
            alt=""
            className={classes.placeholder__icn}
          />

          <UiTypography className={classes.placeholder__text}>
            <Trans>
              AI SMM assistant — tool for creating ready-made posts using
              ChatGPT
            </Trans>
          </UiTypography>
        </div>

        <div className={classes.startBtn}>
          <UiButton
            startIcon={<IconWand />}
            variant="contained"
            size="large"
            onClick={onCreate}
          >
            <Trans>__advisor.start</Trans>
          </UiButton>
        </div>
      </>
    );
  }

  return (
    <div className={classes.contaienr}>
      <UiTypography variant="body2">
        <Trans>
          Automatically generate posts using ChatGPT for your business.
        </Trans>
      </UiTypography>

      <UiTypography variant="body2">
        <Trans>
          You can create {dialogAdvisorConfig.agent_limit} settings sets for AI
          SMM assistant.
        </Trans>
      </UiTypography>

      <div className={classes.head}>
        <UiButton
          variant="semifilled"
          isRounded
          startIcon={<IconPlus />}
          size="small"
          textColor="black"
          onClick={onCreate}
        >
          <Trans>New preset</Trans>
        </UiButton>

        <div className={classes.head__stat}>
          <UiTypography>
            <Trans>Settings presets</Trans>
          </UiTypography>

          <div className={classes.head__stat__val}>
            {value.length} <Trans>of</Trans> {dialogAdvisorConfig.agent_limit}
          </div>
        </div>
      </div>

      <div className={classes.grid}>
        {value.map((agent, idx) => (
          <AgentCard
            key={agent.id}
            agent={agent}
            idx={idx}
            isSaved={updatedAgentId === agent.id}
            onEdit={onEdit}
            onGenerate={onGenerate}
          />
        ))}
      </div>
    </div>
  );
};
